import styled from 'styled-components'

type StyledProps = {
  currStep: number;
}

const StyledCourseRegisterView = styled.div<StyledProps>`
  display: grid;

  .auth-marketing {
    display: ${({ currStep }) => currStep === 0 ? 'block' : 'none'};
  }

  .auth-information {
    padding: 2rem 0;
    grid-template-columns: 100%;
    font-family: ${({ theme }) => theme.fonts.nunito};
    display: ${({ currStep }) => currStep === 0 ? 'none' : 'grid'};

    .wave {
      margin-top: -2rem;
      margin-bottom: -15rem;
      height: 300px;
      position: relative;
      top: -26px;
      pointer-events: none;
      z-index: -1;
    }

    .back-btn {
      display: flex;
      padding-left: 24px;
      justify-content: start;
      margin-bottom: 2rem;

      .btn {
        position: absolute;
        top: 2rem;

        svg {
          height: 24px;
          color: ${({ theme }) => theme.colors.gray[600]};
        }
      }
    }

    .auth-form {
      padding: 0 2rem;

      h1 {
        font-weight: 600;
        font-size: 30px;
        line-height: 37px;
        font-family: ${({ theme }) => theme.fonts.lexend};
        letter-spacing: -0.2px;
        color: ${({ theme }) => theme.colors.gray[700]};
      }

      .breadcrumbs {
        display: flex;
        align-items: center;
        margin-top: 20px;
        font-weight: 300;
        color: ${({ theme }) => theme.colors.gray[300]};
        font-family: ${({ theme }) => theme.fonts.lexend};

        b {
          font-weight: 400;
          color: ${({ theme }) => theme.colors.gray[500]};
        }

        svg {
          height: 16px;
          margin: 0 6px;
        }
      }

      .input-label {
        font-family: ${({ theme }) => theme.fonts.lexend};
        color: ${({ theme }) => theme.colors.gray[600]};
        font-weight: 400;
        font-size: 16px;
      }

      .input-container {
        input {
          font-family: ${({ theme }) => theme.fonts.nunito};
          font-weight: 500;
          font-size: 15px;

          &:-webkit-autofill::first-line {
            font-family: ${({ theme }) => theme.fonts.nunito};
            font-size: 15px;
          }
        }

        svg {
          path {
            stroke-width: 1.5px;
          }
        }
      }

      .row {
        grid-gap: 10px;
      }

      .continue-btn {
        width: 100%;
        font-weight: 400;
        font-size: 1rem;
        letter-spacing: 3px;
        font-family: ${({ theme }) => theme.fonts.lexend};
      }

      .auth-prompt {
        margin-top: 14px;
        display: block;
        text-align: center;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.gray[600]};

        a {
          font-weight: 700;
          font-family: ${({ theme }) => theme.fonts.nunito};
          color: ${({ theme }) => theme.colors.green[500]};
        }
      }

      .checkbox {
        label {
          color: ${({ theme }) => theme.colors.gray[500]};
        }

        margin-bottom: 32px;
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.m}px) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);

    .auth-marketing {
      display: block;
    }

    .auth-information {
      display: grid;
      padding: 156px 0;
      grid-template-columns: minmax(0, 1fr) minmax(0, 420px) minmax(0, 1fr);

      .wave {
        display: none;
      }

      .auth-form {
        padding: 0 1rem;
      }

      .back-btn {
        justify-content: center;
        margin: 0;
        padding-left: 1rem;

        .btn {
          top: unset;
          position: relative;
        }
      }
    }

    .button-prompt {
      display: none;
    }
  }
`

export default StyledCourseRegisterView
